
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-signup",
      function () {
        return require("private-next-pages/customer-signup/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-signup"])
      });
    }
  